import {Dispatchable} from "stem-core/base/Dispatcher";
import {authService} from "../../client/connection/services/AuthService.js";
import {AuthHelper} from "../../blinkpay/AuthHelper.js";
import {isIframe} from "../../blinkpay/Utils.js";
import {iFrameMerchantService} from "../../blinkpay/services/IframeMerchantService.js";


class OAuth1Client extends Dispatchable {
    // Set by Object.assign(this, clientConfig) below - the shape comes from ExternalAuthConfigs.
    // `declare` so no initializer is emitted into the constructor.
    declare authServerUrl: string;
    declare requestTokenEndpoint: string;
    declare loginEndpoint: string;
    declare onLoginCallback: () => void;

    constructor(clientConfig: object) {
        super();
        Object.assign(this, clientConfig);
    }

    // Unlike OAuth2Client, the callback gets no login response.
    setLoginCallback(onLoginCallback: (response?: undefined) => void) {
        this.onLoginCallback = () => onLoginCallback();
    }

    onRequestTokenCallback(response: {oauthToken: string}) {
        const urlParams = new URLSearchParams();
        urlParams.set("oauth_token", response.oauthToken);
        // If we're in an iframe, we send the referral merchant's ID in the OAuth state.
        if (isIframe()) {
            urlParams.set("state", JSON.stringify({merchantId: iFrameMerchantService.merchantId}));
        }

        const url = this.authServerUrl + "?" + urlParams.toString();

        AuthHelper.oauth1TokenReceivedCallback(url);
    }

    async login() {
        AuthHelper.oauth1Login();
        // Request a token from Blink API first
        const response = await authService.requestOAuthToken(this.requestTokenEndpoint);
        this.onRequestTokenCallback(response);
    }

    async handleLoginResponse(urlParams: URLSearchParams) {
        const oauthToken = urlParams.get("oauth_token");
        const oauthVerifier = urlParams.get("oauth_verifier");
        await authService.loginAtEndpoint(this.loginEndpoint, {
            oauthToken,
            oauthVerifier,
            termsAgreed: true,
        });
        this.onLoginCallback();
    }
}

export {OAuth1Client};
